<!-- NGO -->
<div class="features-details-area ptb-80">
  <div class="container">
    <div class="section-title">
      <span class="sub-title" i18n="@@wipperozNgoSubtitle">Helping others</span>

      <div class="bar"></div>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-6 features-details-image">
        <img [src]="ngoSupportImage" class="animate__animated animate__fadeInUp" alt="image" />
      </div>
      <div class="col-lg-6 features-details">
        <div class="features-details-desc">
          <h3 i18n="@@wwipperoNgoTitle">Support to NGOs</h3>
          <p i18n="@@ngoFirstParagraph">
            We seek to generate a true community and contribute to solving real problems. For this, we believe it is
            necessary to incorporate a supportive perspective from the beginning. There is no work more important than
            the work done for the common good and motivated by the dream of a better world. From our humble place, we
            want to contribute to this cause.
          </p>
          <p i18n="@@ngoSecondParagraph">
            We believe that in a global community the most important thing is the synergy that can be achieved by
            linking organizations and joining forces. For this reason, we offer free access to all the services included
            in our platform to all NGOs and to those who want to participate in solidarity activities as volunteers.
          </p>
          <p i18n="@@ngoThirdParagraph">
            If you participate in a NGO, we invite you to contact us so that we can find a way to contribute to your
            goal and discuss in detail the possibilities of our platform.
          </p>
        </div>
      </div>
    </div>
    <div class="separate"></div>
    <app-wipperoz-have-question [questionTitle]="questionTitle"> </app-wipperoz-have-question>
  </div>
</div>
